<template>
  <div v-if="registration && registration.loaded()" class="mb-5">
    <b-row class="mb-2">
      <b-col>
        <h6 class="clickable" v-on:click="$router.push({name: 'admin.competition', params: {id: competition.id}})" v-if="competition.loaded()">
          {{ competition.title() }}
        </h6>

        <h3 :class="'clickable' + (registration.deleted() ? ' red' : '')" v-on:click="$router.push({name: 'admin.schools.details', params: {id: school.id}})" v-if="school.loaded()">
          {{ school.name }}
        </h3>
      </b-col>
    </b-row>

    <b-row class="mb-5">
      <b-col>
        <p>
          {{ school.address }}<br/>
          {{ school.zip }} {{ school.city }}<br/>
          <span v-if="school.state.name !== school.city">{{ school.state.name }}</span>
        </p>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col cols=12 md=5 class="mb-4 mb-md-0">
        <h5>Rechnungsadresse</h5>
        <p v-if="!address.recipient">wie Schule</p>
        <p v-else>
          {{ address.recipient }}<br/>
          {{ address.line1 }}<br/>
          <span v-if="address.line2">{{ address.line2 }}<br/></span>
          <span v-if="address.line3">{{ address.line3 }}<br/></span>
          {{ address.zip }} {{ address.city }}
        </p>
      </b-col>


      <b-col cols=12 md=3 class="mb-4 mb-md-0">
        <h5>Rechnungen</h5>
        <p v-if="invoices.length === 0">Keine</p>

        <b-row v-else v-for="invoice in invoices" :key="invoice.number" class="mb-2">
          <b-col  v-on:click="$eventHub.$emit('download', '/invoice/' + invoice.year + '-' + invoice.number)" class="clickable">
            <font-awesome-icon icon="file-pdf" class="ml-1"></font-awesome-icon>
            {{ invoice.name }}
          </b-col>
        </b-row>
      </b-col>

      <b-col cols=12 md=4 class="mb-4 mb-md-0" v-if="school.coordinator">
        <h5>Koordinator*in</h5>
        <p>
          {{ school.coordinator.gender === 'female' ? 'Frau' : 'Herr' }}
          {{ school.coordinator.firstname }} {{ school.coordinator.lastname }}<br/>
          {{ school.coordinator.email }}
        </p>
      </b-col>
    </b-row>


    <b-row class="mb-5">
      <b-col>
        <h5 class="mb-3">Anmeldungen</h5>
        <class-list :classes="registeredClasses" v-on:save="saveClasses" withSave :disabled="competition.prices"></class-list>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col cols=12 md=4 class="mb-4 mb-md-0">
        <h5 class="mb-3">Zugangscode</h5>

      </b-col>

      <b-col cols=12 md=4 class="mb-4 mb-md-0">

      </b-col>

      <b-col cols=12 md=4 class="mb-4 mb-md-0">

      </b-col>
    </b-row>

    <b-row class="mb-5" v-if="competition.loaded() && registration.loaded()">
      <b-col>
        <h5 class="mb-3">Ergebnisse</h5>
        <prices-table v-if="competition.prices"
            :competition="competition"
            :registration="registration">
        </prices-table>
        <results-table v-else
           :registration="registration"
           :competition="competition">
        </results-table>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="small">
        Angemeldet am {{ registration.createdAt.format('LLLL') }}
        <span v-if="registration.deleted()" class="red"><br/>Gelöscht am {{ registration.deletedAt.format('LLLL') }}</span>
      </b-col>
      <b-col class="text-right">
        <b-button variant="danger" size="sm" v-on:click="this.undelete" v-if="registration.deleted()">Anmeldung wiederherstellen</b-button>
        <b-button variant="danger" size="sm" v-on:click="this.delete" v-else>Anmeldung löschen</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ClassList from '@/components/competitions/registration/ClassList'
import ResultsTable from '@/components/competitions/results/ResultsTable'
import PricesTable from '@/components/competitions/prices/PricesTable'
import { School, Competition, InvoiceAddress, RegisteredClass, RegisteredClassList } from '@/models'
import {CompetitionRegistration} from '../../../models'

export default {
  name: 'CompetitionRegistration',
  props: ['id'],
  components: {
    ClassList,
    ResultsTable,
    PricesTable
  },

  data: function () {
    return {
      registration: null,
      competition: new Competition(),
      school: new School(),
      address: new InvoiceAddress(),
      registeredClasses: new RegisteredClassList(),
      invoices: []
    }
  },

  mounted: function () {
    this.load()
  },

  computed: {
    saveButtonDisabled: function () {
      return this.classes === this.updatedClasses
    }
  },

  methods: {
    load () {
      this.registration = new CompetitionRegistration({id: this.id})
      this.registration.fetch()
        .then(rsp => {
          this.school.id = rsp.data.schoolId
          this.school.fetch()

          this.competition.id = rsp.data.competitionId
          this.competition.fetch()

          this.address.school_id = rsp.data.schoolId
          this.address.fetch()
            .catch(() => { /* ignore */ })

          rsp.data.payload.registeredClasses.forEach(row => {
            this.registeredClasses.add(new RegisteredClass({
              ageGroup: row.ageGroup,
              count: row.count,
              type: row.type
            }))
          })
        })
        .catch(e => this.$eventHub.$emit('error', e))
        .then(() => {
          this.loadInvoices()
        })
    },

    loadInvoices () {
      this.axios.get('/invoice?registration=' + this.registration.id)
        .then(rsp => { this.invoices = rsp.data })
        .catch(() => { /* ignore */ })
    },

    updateClasses (classes) {
      this.updatedClasses = classes
    },

    saveClasses () {
      const classes = []
      this.registeredClasses.each((registeredClass) => {
        classes.push({
          ageGroup: parseInt(registeredClass.ageGroup),
          count: parseInt(registeredClass.count),
          type: registeredClass.type
        })
      })

      this.axios.put('/registrations/' + this.id + '/classes', {
        registeredClasses: classes
      })
        .then(() => this.$eventHub.$emit('success', 'Änderungen gespeichert'))
        .catch(e => this.$eventHub.$emit('error', e))
    },

    delete () {
      const that = this

      const onDelete = function () {
        this.axios.delete('/registrations/' + that.id)
          .then(() => this.$router.replace({name: 'admin.competition', params: {id: that.competition.id}}))
      }

      this.$eventHub.$emit(
        'confirm',
        'Anmeldung wirklich löschen?',
        'Löschen bestätigen',
        onDelete
      )
    },

    undelete () {
      this.axios.patch('/registrations/' + this.id, {deleted: false})
        .then(() => {
          this.registration.deletedAt = false
        })
        .catch(e => this.$eventHub.$emit('error', e))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/competitions/Registration.vue